<template>
  <div
    class="price-formatter"
    :class="{
      unstyled,
      'text-red': priceJustDecreased,
      'text-green': priceJustIncreased,
      'd-flex align-center ga-1': row,
    }"
  >
    <SymbolPriceFormatter
      class="price d-flex align-center"
      v-bind="$attrs"
      v-if="!hideAePrice"
      :ae-price="aePrice"
      :hide-symbol="hideSymbol"
      :price-loading="priceLoading"
      :price-just-increased="priceJustIncreased"
      :price-just-decreased="priceJustDecreased"
      :symbol="symbol"
    />
    <FiatPriceFormatter
      :class="['fiat d-flex align-center ga-1', { 'justify-end': row }]"
      v-bind="$attrs"
      v-if="!hideFiatPrice"
      :fiat-price="fiatPrice"
    />
  </div>
</template>

<script lang="ts" setup>
import { defineProps, PropType, ref, watch } from "vue";

import { Decimal } from "@/libs/decimal";
import { AETERNITY_SYMBOL } from "@/utils/constants";

import FiatPriceFormatter from "@/components/Common/Pricing/FiatPriceFormatter.vue";
import SymbolPriceFormatter from "@/components/Common/Pricing/SymbolPriceFormatter.vue";

const PRICE_CHANGE_DISPLAY_TIME = 1000;

const props = defineProps({
  aePrice: {
    type: Object as PropType<Decimal>,
    required: true,
  },
  fiatPrice: {
    type: Object as PropType<Decimal>,
    required: true,
  },
  symbol: {
    type: String,
    default: AETERNITY_SYMBOL,
  },
  watchPrice: {
    type: Boolean,
    default: true,
  },
  watchKey: String,
  priceLoading: Boolean,
  hideFiatPrice: Boolean,
  hideAePrice: Boolean,
  hideSymbol: Boolean,
  unstyled: Boolean,
  row: Boolean,
});

const priceJustIncreased = ref(false);
const priceJustDecreased = ref(false);

watch(
  () => [props.aePrice, props.watchKey],
  ([value, watchKey], [prev, prevWatchKey]) => {
    if (watchKey !== prevWatchKey) return;
    if (!value || !prev || !props.watchPrice) return;
    if (value.gte(prev)) {
      priceJustIncreased.value = true;
      setTimeout(() => {
        priceJustIncreased.value = false;
      }, PRICE_CHANGE_DISPLAY_TIME);
    } else {
      priceJustDecreased.value = true;
      setTimeout(() => {
        priceJustDecreased.value = false;
      }, PRICE_CHANGE_DISPLAY_TIME);
    }
  }
);
</script>

<style lang="scss" scoped>
.price-formatter {
  &:not(.unstyled) {
    font-weight: 500;

    .fiat {
      opacity: 0.8;
      font-weight: 400;
    }
  }
}
</style>
